export default __webpack_public_path__ + "static/media/mainimage.efa248f6.png";